// ========================================
// 📄 src/components/dashboard/StatCard.jsx (VERSION AMÉLIORÉE)
// ========================================
import React from "react";

const StatCard = ({ icon: Icon, title, value, subtitle, color = "blue", trend, trendValue }) => {
  const colorConfigs = {
    blue: {
      bg: "from-blue-500 to-blue-600",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
      text: "text-blue-600"
    },
    green: {
      bg: "from-green-500 to-green-600",
      iconBg: "bg-green-100",
      iconColor: "text-green-600",
      text: "text-green-600"
    },
    yellow: {
      bg: "from-yellow-500 to-orange-500",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-600",
      text: "text-yellow-600"
    },
    purple: {
      bg: "from-purple-500 to-purple-600",
      iconBg: "bg-purple-100",
      iconColor: "text-purple-600",
      text: "text-purple-600"
    },
    red: {
      bg: "from-red-500 to-red-600",
      iconBg: "bg-red-100",
      iconColor: "text-red-600",
      text: "text-red-600"
    },
  };

  const config = colorConfigs[color];

  return (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
      <div className="flex items-start justify-between mb-4">
        <div className={`p-3 ${config.iconBg} rounded-xl`}>
          <Icon className={`w-6 h-6 ${config.iconColor}`} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 text-sm font-semibold ${config.text}`}>
            <span className={trend === 'up' ? 'text-green-500' : 'text-red-500'}>
              {trend === 'up' ? '↗' : '↘'}
            </span>
            {trendValue}%
          </div>
        )}
      </div>
      
      <div>
        <p className="text-sm font-medium text-gray-600 mb-2">{title}</p>
        <p className="text-3xl font-bold text-gray-800 mb-1">{value}</p>
        {subtitle && (
          <p className="text-sm text-gray-500 flex items-center gap-1">
            <span className="w-2 h-2 bg-gray-300 rounded-full"></span>
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default StatCard;
